



























































































































































































/* eslint-enable @typescript-eslint/camelcase */
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import { ValidationObserver } from 'vee-validate';

import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import FormInput from '@/components/FormInput.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Select from '@/components/Select.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { DetailChannel, PriceTier } from '@/libs/api.interfaces';
import BillingFields from '../../components/BillingFields.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    FormInput,
    ValidationObserver,
    Button,
    Select,
    BillingFields,
  },
})
export default class ReportDetail extends Vue {
  /* eslint-disable @typescript-eslint/camelcase */
  @Prop(String) mcode!: string;
  @Prop(String) channelID!: string;
  @Prop(String) scChannelID!: string;
  @Prop(String) editedChannel!: string;
  @Prop(String) channelInput!: string;
  @Prop(String) phase!: string;

  loading = false;
  secretKey = '';
  brandName = '';
  bankId = '';
  bankSubId = '';
  billingType: null | string = null;
  paymentFlag = '';
  inquiryPath = '';
  notificationEmail = '';
  // moduleVersion = '';
  refundFee = '';

  billingTypesMaybank = ['Full', 'Partial', 'Open'];

  billingTypes = [
    { label: 'Normal', value: 'normal' },
    { label: 'MDR', value: 'mdr' },
    { label: 'Tiering per Traffic', value: 'tiring' },
    { label: 'Tiering per Amount', value: 'tiring_amount' },
  ];

  billing: BillingFieldsModel = {
    bussinessType: '',
    transactionFeeType: { label: 'Normal', value: 'normal' },
    transactionFeeValue: '',
    feeBank: '',
    includePPN: false,
    bussinessModel: { label: 'Direct Bundling', value: '0' },
    description: '',
    live: false,
  }

  bussinessModels = [
    { label: 'Direct Bundling', value: '0' },
    { label: 'Direct Non Bundling', value: '1' },
    { label: 'Escrow', value: '2' },
  ];

  token = '';

  mounted() {
    if (this.channelID !== '' && this.editedChannel === 'Maybank Virtual Account') {
      this.getChannel();
    }
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
  }

  close() {
    this.$emit('modal', false);
  }

  async getChannel() {
    const credentials = 'credentials';
    try {
      this.loading = true;
      let data: DetailChannel;
      if (this.phase === 'production') {
        ({ data } = await apiProduction.get<DetailChannel>('consumer/channel/setting', {
          params: {
            credentials,
            channel_id: this.channelID,
            merchant_code: this.$route.params.type,
          },
        }));
      } else {
        ({ data } = await apiSandbox.get<DetailChannel>('consumer/channel/setting', {
          params: {
            credentials,
            channel_id: this.channelID,
            merchant_code: this.$route.params.type,
          },
        }));
      }
      this.secretKey = data.secretkey;
      let url = '';
      if (data.use_ssl && (Number(data.http_port) === 443 || data.http_port === '443')) {
        url = `http${data.use_ssl ? 's:' : ':'}//${data.http_host}${data.payment_path}`;
      } else if (!data.use_ssl && (Number(data.http_port) === 80 || data.http_port === '80')) {
        url = `http${data.use_ssl ? 's:' : ':'}//${data.http_host}${data.payment_path}`;
      } else {
        // eslint-disable-next-line max-len
        url = `http${data.use_ssl ? 's:' : ':'}//${data.http_host}:${data.http_port !== '' ? data.http_port : ''}${data.payment_path}`;
      }

      this.paymentFlag = url;
      this.inquiryPath = data.inquiry_path;
      this.bankSubId = data.banksub_id;
      this.notificationEmail = data.email_reporting;
      // this.moduleVersion = data.module_version;
      this.refundFee = data.fee_refund.toString();

      this.bankId = data.bank_id;
      this.brandName = data.brand_name;
      this.billingType = this.billingTypesMaybank.find((e) => e[0] === data.bill_type) || null;
      this.notificationEmail = data.email_notification;

      const type = data.billType || 'normal';

      this.billing = {
        bussinessType: data.business_type,
        transactionFeeType: this.billingTypes.find((e) => e.value === type) || { label: 'Normal', value: 'normal' },
        feeBank: data.fee_bank ? data.fee_bank.toString() : '',
        includePPN: data.ppn === 1,
        bussinessModel: this.bussinessModels.find((e) => e.value === type) || { label: 'Direct Bundling', value: '0' },
        description: data.descp,
        transactionFeeValue: type === 'normal' || type === 'mdr'
          ? (data.price as string) : (data.price as PriceTier[]).map((e) => ({
            min: e.traffic_min.toString() || '0',
            max: e.traffic.toString() || '0',
            price: e.price.toString() || '0',
            type: e.type || '',
          })),
        live: data.status !== '0',
      };

      this.loading = false;
    } catch (err) {
      console.error(err);
      this.loading = false;
      this.$emit('exitComponent', this.phase);
      // showToast(
      //   ToastType.FAILED,
      //   `Error[${(err as AxiosError).response?.status}]`,
      //   'Failed to get channel detail',
      // );
    }
  }

  async submit() {
    this.loading = true;
    let feeValue;
    const statusLive = this.billing.live ? '1' : '0';
    if (this.billing.transactionFeeType.value === 'tiring'
        || this.billing.transactionFeeType.value === 'tiring_amount') {
      feeValue = (this.billing.transactionFeeValue as Tier[]).map((e) => ({
        traffic_min: e.min,
        traffic: e.max,
        price: e.price,
        type: e.type,
      }));
    } else {
      feeValue = this.billing.transactionFeeValue;
    }

    try {
      const dataSubmit = {
        auto: 0,
        service_code: this.$data.service_code || '1052',
        merchant_code: this.$route.params.type,
        channel_id: this.phase === 'production' ? this.scChannelID : this.channelID,
        // trans_fee_type: '5000', // ??
        // trans_fee_value: '2111', // ??
        // module_version: this.moduleVersion,
        payment_url: this.paymentFlag,
        // fee_settlement: '5000', // ??
        fee_refund: this.refundFee,
        fee_bank: 0,
        // fee_sprint: '5000', // ??
        // fee_transaction: '5000', // ??
        isEscrow: 1, // ??
        bank_id: this.bankId,
        brand_name: this.brandName,
        banksub_id: this.bankSubId,
        inquiry_url: this.inquiryPath,
        bill_type: this.billing.transactionFeeType.value,
        price: feeValue,
        ppn: this.billing.includePPN ? '1' : '0',
        descp: this.billing.description,
        business_type: this.billing.bussinessType,
        business_model: this.billing.bussinessModel.value,
        billType: (this.billingType as string), // kurang di bima?
        email_notification: this.notificationEmail,
        // cc_flag: {
        //   sale_authorization: '111',
        //   capture: '0',
        //   'void_void-capture_refund': '1',
        // }, // ??
        // transaction_type: JSON.stringify([]), // tidak ada di merchant configurator
        only_channel: 1,
        copy_price_lead: this.phase === 'production' && this.channelID !== '' ? 1 : 0,
        status: this.phase === 'production' ? statusLive : '1',
      };

      if (this.channelID) {
        await (this.phase === 'production' ? apiProduction : apiSandbox)
          .put(`/merchant/channel/${this.$route.params.type}`, dataSubmit, {
            headers: {
              token: this.token,
            },
          });
        showToast(ToastType.SUCCESS, `Update ${this.phase} success`,
          `${this.editedChannel} ${this.channelID} updated`);
      } else {
        await (this.phase === 'production' ? apiProduction : apiSandbox)
          .post('/merchant/channel', dataSubmit, {
            headers: {
              token: this.token,
            },
          });
        showToast(ToastType.SUCCESS, `Add ${this.phase} success`,
          `${this.editedChannel} ${this.channelID} added`);
      }
      this.getChannel();
      // this.close();
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data);
      this.loading = false;
    }
  }
}
